import { Utils } from '@everyboard/lib';
import { Coord } from '../Coord';
import { HexaLine } from '../HexaLine';
import { GameStateWithTable } from './GameStateWithTable';
export class HexagonalGameState extends GameStateWithTable {
    width;
    height;
    excludedSpaces;
    empty;
    constructor(turn, board, width, height, excludedSpaces, empty) {
        super(board, turn);
        this.width = width;
        this.height = height;
        this.excludedSpaces = excludedSpaces;
        this.empty = empty;
        Utils.assert(this.excludedSpaces.length < (this.height / 2) + 1, 'Invalid excluded spaces specification for HexagonalGameState.');
    }
    setAt(coord, v) {
        if (this.isOnBoard(coord)) {
            return this.setAtUnsafe(coord, v);
        }
        else {
            throw new Error('Setting coord not on board: ' + coord + '.');
        }
    }
    equalsT(other, equal) {
        if (this === other) {
            return true;
        }
        if (this.width !== other.width) {
            return false;
        }
        if (this.height !== other.height) {
            return false;
        }
        if (equal(this.empty, other.empty) === false) {
            return false;
        }
        if (this.excludedSpaces.length !== other.excludedSpaces.length) {
            return false;
        }
        for (let i = 0; i < this.excludedSpaces.length; i++) {
            if (this.excludedSpaces[i] !== other.excludedSpaces[i]) {
                return false;
            }
        }
        return this.findMatchingCoord((coord, content) => {
            return equal(content, other.getPieceAt(coord)) === false;
        }).isAbsent();
    }
    allLines() {
        const lines = [];
        for (let i = 0; i < this.width; i++) {
            lines.push(HexaLine.constantQ(i));
        }
        for (let i = 0; i < this.height; i++) {
            lines.push(HexaLine.constantR(i));
        }
        for (let i = this.excludedSpaces.length; i < this.height + this.excludedSpaces.length; i++) {
            lines.push(HexaLine.constantS(i));
        }
        return lines;
    }
    getEntranceOnLine(line) {
        let x;
        let y;
        switch (line.constant) {
            case 'q':
                if (this.excludedSpaces[line.offset] != null) {
                    y = this.excludedSpaces[line.offset];
                }
                else {
                    y = 0;
                }
                return this.findEntranceFrom(line, new Coord(line.offset, y));
            case 'r':
                if (this.excludedSpaces[line.offset] != null) {
                    x = this.excludedSpaces[line.offset];
                }
                else {
                    x = 0;
                }
                return this.findEntranceFrom(line, new Coord(x, line.offset));
            case 's':
                if (line.offset < this.width) {
                    return this.findEntranceFrom(line, new Coord(line.offset, 0));
                }
                else {
                    return this.findEntranceFrom(line, new Coord(this.width - 1, line.offset - this.width + 1));
                }
        }
    }
    findEntranceFrom(line, start) {
        const dir = line.getDirection();
        let coord = start;
        for (let i = 0; i < Math.max(this.width, this.height); i++) {
            if (this.isOnBoard(coord)) {
                return coord;
            }
            coord = coord.getNext(dir);
        }
        const failure = Utils.logError('HexagonalGameState.findEntranceFrom', 'could not find a board entrance, board must be invalid', { start: start.toString(), line: line.toString() });
        throw new Error(failure.getReason());
    }
}
